import { render } from "./WeekDayTotals.vue?vue&type=template&id=90e86d2a"
import script from "./WeekDayTotals.vue?vue&type=script&lang=js"
export * from "./WeekDayTotals.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__